import { getBasePath } from '../../utils/config';
import {
  IgetCatalogReferencesAPIBody,
  IgetCatalogReferencesAPIResponse,
  IgetCatalogUpdateReferencesFiltersAPIResponse,
  IupdateCatalogReferencesAPIBody,
  IupdateCatalogReferencesAPIResponse,
} from './catalogUpdateReferences.response.interface';

export const getCatalogUpdateReferencesAPI = async (
  body: IgetCatalogReferencesAPIBody,
  signal: AbortSignal,
  token: string
): Promise<IgetCatalogReferencesAPIResponse> => {
  const params = {
    signal: signal,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/product_management/brand_catalog`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const getCatalogUpdateReferencesFiltersAPI = async ({
  brandId,
  token,
}: {
  brandId: string;
  token: string;
}): Promise<IgetCatalogUpdateReferencesFiltersAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/product_management/filter?brand_id=${brandId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const updateCatalogReferencesAPI = async (
  body: IupdateCatalogReferencesAPIBody,
  token: string
): Promise<IupdateCatalogReferencesAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/product_management/update_product`,
    params
  );
  const data = await response.json();
  return { response, data };
};
